import { useAppSelector } from 'hooks/useAppSelector';
import { IntlKey } from 'locales';
import { FormattedMessage } from 'react-intl';
import { FormIdProps } from 'shared/props';
import { FormFieldId } from 'state/formData';
import { selectFieldIdValue } from 'state/formData/formData.selectors';
import { selectEssentialWorkspaceTabProductVariation } from 'state/selectors';

export function Product({ formId }: FormIdProps) {
  const productSubtype = useAppSelector(state => {
    const formProductSubtype = selectFieldIdValue(state, formId, 'ProductSubtype' satisfies FormFieldId) as
      | string
      | undefined;

    const tabProductVariation = selectEssentialWorkspaceTabProductVariation(state, formId);
    return formProductSubtype ?? tabProductVariation?.productSubtype;
  });

  return (
    productSubtype && (
      <span className="lh-1 fw-normal text-truncate mw-100">
        <FormattedMessage id={`field.${productSubtype}` as IntlKey} defaultMessage={productSubtype} />
      </span>
    )
  );
}
